function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    opacity: 0;\n    width: 0;\n  }\n  to {\n    opacity: 1;\n    width: ",
        "px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    opacity: 1;\n    width: ",
        "px;\n  }\n  to {\n    opacity: 0;\n    width: 0;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    opacity: 0;\n    width: 0;\n  }\n  to {\n    opacity: 1;\n    width: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    opacity: 1;\n    width: ",
        ";\n  }\n  to {\n    opacity: 0;\n    width: 0;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  from {\n    opacity: 1;\n  }\n  to { \n    opacity: 0;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
import { useBuildStyleWithTheme } from "../../ThemeProvider/useBuildStyleWithTheme";
import { keyframes } from "@emotion/react";
import { useContext } from "react";
import { CarinaContext } from "../../CarinaProvider";
var SIDE_WIDTH = 320;
var FULL_WIDTH = '100vw';
var animationMultiplier = 1;
var OUTER_DURATION = 200 * animationMultiplier;
var CONTENT_DURATION = 200 * animationMultiplier;
export var animationOutDuration = OUTER_DURATION + CONTENT_DURATION;
var outerContainerIn = keyframes(_templateObject(), SIDE_WIDTH);
var outerContainerOut = keyframes(_templateObject1(), SIDE_WIDTH);
var outerContainerInSmall = keyframes(_templateObject2(), FULL_WIDTH);
var outerContainerOutSmall = keyframes(_templateObject3(), FULL_WIDTH);
var outerContainerInFade = keyframes(_templateObject4());
var outerContainerOutFade = keyframes(_templateObject5());
function buildStyle(param, param1) {
    var backgroundColor = param.backgroundColor, borderColor = param.borderColor, animation = param.animation, readingDirection = param1.readingDirection, end = param1.end;
    var _obj;
    return {
        wrapper: {
            base: _objectSpread({}, readingDirection, (_obj = {
                overflow: 'auto',
                backgroundColor: backgroundColor.base,
                height: '100%',
                width: SIDE_WIDTH
            }, _defineProperty(_obj, end.borderWidth, 1), _defineProperty(_obj, end.borderStyle, 'solid'), _defineProperty(_obj, end.borderColor, borderColor.soft), _defineProperty(_obj, "flexShrink", 0), _defineProperty(_obj, "flexGrow", 0), _obj)),
            animateIn: {
                animation: "".concat(outerContainerIn, " ").concat(animation.duration[400], " ").concat(animation.expressive.easeOut.easing),
                animationFillMode: 'forwards'
            },
            animateOut: {
                animation: "".concat(outerContainerOut, " ").concat(animation.duration[200], " ").concat(animation.expressive.easeOut.easing),
                animationFillMode: 'both'
            },
            reducedMotionAnimateIn: {
                animation: "".concat(outerContainerInFade, " ").concat(animation.duration.reducedMotion, " ").concat(animation.linear.easing),
                animationFillMode: 'forwards'
            },
            reducedMotionAnimateOut: {
                animation: "".concat(outerContainerOutFade, " ").concat(animation.duration.reducedMotion, " ").concat(animation.linear.easing),
                animationFillMode: 'both'
            }
        },
        wrapperSmall: {
            base: {
                width: FULL_WIDTH
            },
            animateIn: {
                animation: "".concat(outerContainerInSmall, " ").concat(animation.duration[400], " ").concat(animation.expressive.easeOut.easing),
                animationFillMode: 'forwards'
            },
            animateOut: {
                animation: "".concat(outerContainerOutSmall, " ").concat(animation.duration[200], " ").concat(animation.expressive.easeOut.easing)
            },
            reducedMotionAnimateIn: {
                animation: "".concat(outerContainerInFade, " ").concat(animation.duration.reducedMotion, " ").concat(animation.linear.easing),
                animationFillMode: 'forwards'
            },
            reducedMotionAnimateOut: {
                animation: "".concat(outerContainerOutFade, " ").concat(animation.duration.reducedMotion, " ").concat(animation.linear.easing)
            }
        },
        list: {
            listStyle: 'none',
            padding: 0,
            marginTop: 8,
            marginBottom: 0,
            marginLeft: 0,
            marginRight: 0
        }
    };
}
export default function useStyle(param) {
    var isOpen = param.isOpen, isRtl = param.isRtl, shouldAnimate = param.shouldAnimate, breakpoints = param.breakpoints;
    var ref;
    var prefersReducedMotion = ((ref = useContext(CarinaContext)) !== null && ref !== void 0 ? ref : {
        prefersReducedMotion: false
    }).prefersReducedMotion;
    var builtStyle = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    });
    if (!builtStyle) {
        return {
            wrapperStyles: {},
            listStyles: {}
        };
    }
    var wrapper = builtStyle.wrapper, wrapperSmall = builtStyle.wrapperSmall, list = builtStyle.list;
    var animateIn = prefersReducedMotion ? wrapper.reducedMotionAnimateIn : wrapper.animateIn;
    var animateOut = prefersReducedMotion ? wrapper.reducedMotionAnimateOut : wrapper.animateOut;
    var animateInSmall = prefersReducedMotion ? wrapperSmall.reducedMotionAnimateIn : wrapperSmall.animateIn;
    var animateOutSmall = prefersReducedMotion ? wrapperSmall.reducedMotionAnimateOut : wrapperSmall.animateOut;
    return {
        wrapperStyles: _objectSpread({}, wrapper.base, isOpen ? {
            width: SIDE_WIDTH
        } : {
            width: 0,
            borderWidth: 0
        }, shouldAnimate ? animateIn : {}, shouldAnimate && !isOpen ? animateOut : {}, _defineProperty({}, "@media (max-width: ".concat(breakpoints.m, "px)"), _objectSpread({}, wrapper.base, isOpen ? {
            width: FULL_WIDTH
        } : {
            width: 0,
            borderWidth: 0
        }, shouldAnimate && isOpen ? animateInSmall : {}, shouldAnimate && !isOpen ? animateOutSmall : {}))),
        listStyles: list
    };
};
